import * as React from 'react';

import { useIntl } from 'react-intl';

import { IDeliveryAddress } from 'generated/rbi-graphql';

import { DeliveryAddressesList } from './delivery-addresses-list';

type RecentAddressProps = {
  addresses: IDeliveryAddress[];
  onAddressSelect: (address: IDeliveryAddress) => void;
  onEditAddress?: (address: IDeliveryAddress) => void;
};

export const RecentAddresses: React.FC<RecentAddressProps> = ({
  addresses,
  onEditAddress,
  onAddressSelect,
}) => {
  const { formatMessage } = useIntl();

  if (!addresses || addresses.length < 1) {
    return null;
  }

  return (
    <DeliveryAddressesList
      showEdit={false}
      addresses={addresses}
      onEditAddress={onEditAddress}
      onAddressSelect={onAddressSelect}
      label={formatMessage({ id: 'recentAddresses' })}
    />
  );
};
